import { LoggerService } from './logger.service';
import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';

@Component({
    template: ``,
    standalone:true

})
export class RedirectComponent implements OnInit {
  static _path_file='app/shared/redirect.component.ts';
  constructor(private activatedRoute: ActivatedRoute, private router: Router, private _logger: LoggerService) { }

  ngOnInit() {
    this.activatedRoute.params.subscribe(params => {
      this.router.navigate(['signin']);
    });
  }
}
